import React, { useState, useEffect, useCallback } from 'react';
import './App.css';
import { applySavedTheme } from './components/ThemeToggle';
import { supabase } from './supabaseClient';

import AdminPanel from './components/AdminPanel';
import SuperAdminPanel from './components/SuperAdminPanel';
import ProfilHatasi, { profilOku } from './components/ProfilHatasi';   // profil okunamadı ≠ yok (21 Eki 2026)
import { oturumDegisti } from './components/sirketDilimi';   // oturum sahibi değişince şirket dilimi önbelleği boşalır (K20)
import { applyFont, kayitliBoyut, TAM_YUKSEKLIK } from './yaziBoyutu';

// 10 Agu 2026 (Serkan): SUPER ADMIN aciliste SIRKET LISTESINE duser — konfigurasyon her zaman bir sirkete
// aittir, once sirket secilir.
// 🔑 1 Eki 2026 (Serkan, ofis talebi): *"web'de artik herkes icin giriste admin panel acilacak"* · *"artik
//    dashboard olmayacak"*. Rol kisitlamalari sonraki rol/yetki isinde (Serkan: "ilerideki is").
const landing = (prof) => (prof?.is_super_admin ? 'superadmin' : 'admin');

// Tema, ilk boyamadan önce uygulanır (efb_theme: dark/light)
applySavedTheme();


// ─── Global Font Size ─────────────────────────────────────────────────────────
// Yazı boyutu ve tam yükseklik TEK kaynaktan (yaziBoyutu.js — 30 Eyl 2026).

// ─── ESKİ WEB PİLOT EKRANLARI KALKTI (21 Eki 2026, K1) ─────────────────────────
// 🔑 Serkan: *"silelim, eski pilot ekranları en baştaki geçici tasarım gereğiydi, artık web direkt admine açılıyor,
//    pilotu ilgilendiren bir yer değil"*. 1 Eki'den beri hiçbir yerden açılamıyordu (operational sayfasına yalnız
//    kendi menüsü götürüyordu). 17 dosya (~5.200 satır) ve kabuğu gitti; pilot uygulaması iPad'dir.
// Tarayıcılarda kalan eski anahtarlar bir kez silinir — `efb_rawText` bir OFP'nin tam metnini taşıyabiliyordu ve
// eski aktif plan her açılışta gereksiz bir `plan_versions` sorgusu attırıyordu.
const ESKI_ANAHTARLAR = ['efb_activePlan', 'efb_activePage', 'efb_flightData', 'efb_pageStatus', 'efb_divertData', 'efb_rawText'];
try { ESKI_ANAHTARLAR.forEach(k => localStorage.removeItem(k)); } catch { /* depolama kapalı: silecek bir şey yok */ }


// ─── Login ────────────────────────────────────────────────────────────────────
// 26 Eki 2026 (Serkan B): baslik "Pilot Login" -> "Admin Panel", ornek e-posta pilot@ -> name@. Web yalniz admin paneline
// acilir; pilotun kapisi iPad (Serkan: "iPad zaten pilot girisi" · "webde admin"). Eski web pilot ekranlari K1'de silinmisti.
function Login({ onLogin }) {
  const [email, setEmail]     = useState('');
  const [pass, setPass]       = useState('');
  const [error, setError]     = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    setLoading(true);
    setError('');
    // E-posta bosluk/buyuk-kucuk harf yuzunden eslesmesin diye normallestirilir
    // (Supabase e-postayi kucuk harfte tutar). Sifreye DOKUNULMAZ.
    const { error: authError } = await supabase.auth.signInWithPassword({
      email: email.trim().toLowerCase(), password: pass,
    });
    // 11 Agu 2026: eskiden HER hata "Invalid email or password." diye
    // gosteriliyordu; gercek sebep (onaylanmamis e-posta, hiz siniri, ag hatasi)
    // gizleniyordu ve saha teshisi imkansizdi. Sistem bildigi seyi soyler.
    if (authError) setError(authError.message || 'Sign-in failed.');
    else onLogin();
    setLoading(false);
  };

  return (
    <div style={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', minHeight:TAM_YUKSEKLIK, background:'var(--bg)' }}>
      <div style={{ textAlign:'center', marginBottom:36 }}>
        {/* MARKALASMA (30 Tem, iOS ile ayni): urun adi GO2 eFB — sirket/musteri adi login'de gecmez */}
        <div style={{ fontSize:11, fontWeight:700, color:'var(--accent)', letterSpacing:3, textTransform:'uppercase', marginBottom:6 }}>GO2</div>
        <div style={{ fontSize:32, fontWeight:700, color:'var(--t1)' }}>eFB</div>
        <div style={{ fontSize:12, color:'var(--t3)', marginTop:4 }}>Electronic Flight Bag</div>
      </div>
      <div style={{ width:300, background:'var(--bg2)', border:'1px solid var(--border)', borderRadius:12, overflow:'hidden' }}>
        <div style={{ background:'var(--bg3)', borderBottom:'1px solid var(--border)', padding:'10px 18px', fontSize:10, color:'var(--t3)', fontWeight:700, letterSpacing:1, textTransform:'uppercase' }}>Admin Panel</div>
        <div style={{ padding:'12px 18px', borderBottom:'1px solid rgba(255,255,255,0.04)' }}>
          <label style={{ display:'block', fontSize:10, color:'var(--t3)', fontWeight:700, letterSpacing:0.8, textTransform:'uppercase', marginBottom:5 }}>Email</label>
          <input value={email} onChange={e => setEmail(e.target.value)} placeholder="name@company.com"
            style={{ width:'100%', background:'var(--input-bg)', border:'1px solid var(--border)', borderRadius:6, padding:'9px 11px', fontSize:14, color:'var(--t1)', fontFamily:'inherit', outline:'none' }} />
        </div>
        <div style={{ padding:'12px 18px' }}>
          <label style={{ display:'block', fontSize:10, color:'var(--t3)', fontWeight:700, letterSpacing:0.8, textTransform:'uppercase', marginBottom:5 }}>Password</label>
          <input type="password" value={pass} onChange={e => setPass(e.target.value)} onKeyDown={e => e.key === 'Enter' && handleLogin()}
            style={{ width:'100%', background:'var(--input-bg)', border:'1px solid var(--border)', borderRadius:6, padding:'9px 11px', fontSize:14, color:'var(--t1)', fontFamily:'inherit', outline:'none' }} />
        </div>
        {error && <div style={{ margin:'0 18px', padding:'8px 10px', borderRadius:5, background:'var(--red-soft)', borderLeft:'3px solid var(--red)', fontSize:11, color:'var(--red)' }}>{error}</div>}
        <button onClick={handleLogin} disabled={loading}
          style={{ width:'calc(100% - 36px)', margin:'14px 18px', background: loading ? 'var(--bg3)' : 'var(--accent)', border:'none', borderRadius:7, padding:12, fontSize:14, fontWeight:700, color:'#fff', cursor: loading ? 'default' : 'pointer', fontFamily:'inherit' }}>
          {loading ? 'Signing in...' : 'Sign In'}
        </button>
      </div>
      <div style={{ marginTop:20, fontSize:10, color:'var(--t3)' }}>GO2 eFB · For internal use only</div>
    </div>
  );
}

// PlanCard ve Dashboard 1 Eki 2026'da kalktı: kart `components/PlanCard.js`'te, Dashboard'un işlevleri admin
// panelde FLT OPS'ta (Serkan: "artık dashboard olmayacak — dashboard'u FLT OPS içine taşımış olacağız").

// ─── App ──────────────────────────────────────────────────────────────────────
function App() {
  const [page, setPage]                   = useState('loading');

  useEffect(() => {
    applyFont(kayitliBoyut());
  }, []);

  // 21 Eki 2026 (W4b): profil okunamazsa yönlendirme YAPILMAZ — `ProfilHatasi` ekranı (RETRY / LOGOUT). Eskiden düşen
  // okuma "profil yok" sayılıp herkes (süper admin dahil) şirketsiz admin paneline gidiyordu.
  const [profilHatasi, setProfilHatasi] = useState(null);
  const profiliYenidenDene = useCallback(async () => {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) { setPage('login'); return; }
    const r = await profilOku(session.user.id);
    setProfilHatasi(r.hata);
    setPage(r.hata ? 'profilHatasi' : landing(r.profil));
  }, []);

  useEffect(() => {

    supabase.auth.getSession().then(async ({ data: { session } }) => {
      if (session) {
        const r = await profilOku(session.user.id);
        setProfilHatasi(r.hata);
        setPage(r.hata ? 'profilHatasi' : landing(r.profil));
      } else {
        setPage('login');
      }
    });

    // 🔴 GERI CAGIRMA ASENKRON OLMAMALI (10 Agu 2026, saha: sayfa 'loading'
    // ekraninda asili kaldi). supabase-js v2'de onAuthStateChange geri cagirmasi
    // AUTH KILIDININ ICINDE kosar; icinde await ile baska bir supabase cagrisi
    // yapilirsa getSession() ayni kilidi bekler ve uygulama hic acilmaz.
    // Cozum: geri cagirma ANINDA doner, is setTimeout(...,0) ile kilidin
    // DISINA atilir. Bu, Supabase'in kendi belgelenmis kuralidir.
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      oturumDegisti(session?.user?.id || null);   // senkron, supabase çağrısı yok — kilit kuralına uyar
      if (!session) { setPage('login'); return; }
      setTimeout(async () => {
        const r = await profilOku(session.user.id);
        // YALNIZ giristen sonra yonlendir. Bu dinleyici token yenilemede de
        // tetikleniyor; kosulsuz setPage yazarsak kullanici calisirken sayfa
        // kendiliginden basa doner.
        setProfilHatasi(r.hata);
        setPage(p => (p === 'login' || p === 'loading' || p === 'profilHatasi')
          ? (r.hata ? 'profilHatasi' : landing(r.profil)) : p);
      }, 0);
    });
    return () => subscription.unsubscribe();
  }, []);

  if (page === 'loading') return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', minHeight:TAM_YUKSEKLIK, background:'var(--bg)' }}>
      <div style={{ fontSize:13, color:'var(--t3)' }}>Loading...</div>
    </div>
  );

  // Yonlendirmenin TEK SAHIBI oturum dinleyicisidir (super admin -> sirket
  // listesi, digerleri -> dashboard). Login BURADA sayfa DEGISTIRMEZ: degistirse
  // dinleyiciyle yarisa girer ve sirasi ters donerse kullanici 'loading'
  // ekraninda asili kalir (baska auth olayi gelmez).
  if (page === 'login') return <Login onLogin={() => {}} />;
  if (page === 'profilHatasi') return <ProfilHatasi hata={profilHatasi} onRetry={profiliYenidenDene} sonra={() => setPage('login')} />;
  if (page === 'admin') return <AdminPanel onBack={() => setPage('login')} />;
  if (page === 'superadmin') return <SuperAdminPanel onBack={() => setPage('admin')} onCikis={() => setPage('login')} />;
  return null;
}

export default App;